@if (loading) {
  <bt-spinner-overlay [opaque]="true"></bt-spinner-overlay>
}

<div class="dashboard-page">
  <mat-card appearance="filled" fxFlex="100%">
    <mat-card-title fxLayout="row" fxLayoutAlign="center center">
      @if (organizationName) {
        <span class="header-text">{{organizationName}} D<small>&</small>A</span>
      }
    </mat-card-title>

    <mat-card-content fxLayout="column" fxFlex="100%">
      <div id="dashboard" class="dashboard-div"></div>
    </mat-card-content>
  </mat-card>
</div>
